import React from 'react';
import PropTypes from 'prop-types';
import LoginLayout from '~/layout/LoginLayout';
import Mask from '~/layout/Mask';
// eslint-disable-next-line import/no-unresolved
import './index.less';

const WebAccessError = ({imgSrc, imgAlt, title, msg}) => (
    <Mask>
        <LoginLayout>
            <div className="web-access-error-wrapper">
                <div className="access-error">
                    <div className="img-wrapper">
                        <img
                            src={imgSrc}
                            alt={imgAlt}
                        />
                    </div>

                    <p className="title">
                        {title}
                    </p>
                    <p className="msg">
                        {msg}
                    </p>
                </div>
            </div>
        </LoginLayout>
    </Mask>
);

WebAccessError.propTypes = {
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    msg: PropTypes.string.isRequired,
};

export default WebAccessError;
